var App = App || {};

App.Cookies = (() => {
    'use strict';

    const getItem = (key) => {
        if (!key) return null;
        const regex = new RegExp(`(?:^|.*;)\\s*${encodeURIComponent(key).replace(/[-.+*]/g, '\\$&')}\\s*=\\s*([^;]*).*$|^.*$`);
        return decodeURIComponent(document.cookie.replace(regex, '$1')) || null;
    };

    const setItem = (key, value, end, path, domain, secure) => {
        if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) return false;

        let expires = '';
        if (end) {
            if (typeof end === 'number') {
                expires = end === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : `; max-age=${end}`;
            } else if (typeof end === 'string') {
                expires = `; expires=${end}`;
            } else if (end instanceof Date) {
                expires = `; expires=${end.toUTCString()}`;
            }
        }

        document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}${expires}${domain ? `; domain=${domain}` : ''}${path ? `; path=${path}` : ''}${secure ? '; secure' : ''}`;
        return true;
    };

    const removeItem = (key, path, domain) => {
        if (!hasItem(key)) return false;
        document.cookie = `${encodeURIComponent(key)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${domain ? `; domain=${domain}` : ''}${path ? `; path=${path}` : ''}`;
        return true;
    };

    const hasItem = (key) => {
        if (!key) return false;
        return new RegExp(`(?:^|;\\s*)${encodeURIComponent(key).replace(/[-.+*]/g, '\\$&')}\\s*=`).test(document.cookie);
    };

    const keys = () => {
        const cookies = document.cookie.replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:=[^;]*)?;\s*/);
        return cookies.map((cookie) => decodeURIComponent(cookie));
    };

    return {
        getItem,
        setItem,
        removeItem,
        hasItem,
        keys,
    };
})();